<app-html-news [news]="news"></app-html-news>

<div class="table-container">
  <app-online-results-table
    [table]="news.results"
    [physics]="news.cup.physics"
    [cupId]="news.cup.id"
    [ngClass]="{
      'online-results-table': true,
    }"
    data-test-id="online-results-table"
  >
  </app-online-results-table>
</div>
